import { GlobalAlertContextProvider } from '@thoughtspot/global-alert';
import { UserAction, userActionTypeEnum } from '@thoughtspot/metrics';
import React from 'react';
import { useBlinkContextForGlobalNav } from "../../contexts/global-nav-blink-context";
import { HelpMenu } from "./help-menu";
export const HelpMenuContainer = ({ isPendoHelpEnabled, learningModule, }) => {
    const { sessionService, metricsService, navService, systemConfigService, observabilityService, } = useBlinkContextForGlobalNav();
    const sendMixpanelEvent = () => {
        metricsService.collectEvent(new UserAction(userActionTypeEnum.TOP_NAV_INFO_CENTER_CLICK), {});
    };
    const { getReleaseVersion, getBaseReleaseVersion, getHelpConfig, getOnlineDocUrl, getInAppHelpUrl, isSaaSCluster, getSupportConfigItems, } = sessionService;
    const { isIntercomEnabled } = systemConfigService;
    const baseReleaseVersion = getBaseReleaseVersion();
    const releaseVersion = getReleaseVersion();
    const helpConfigList = (getHelpConfig() || []);
    const onlineDocUrl = getOnlineDocUrl();
    const inAppHelpUrl = getInAppHelpUrl();
    const saasCluster = isSaaSCluster();
    const intercomEnabled = isIntercomEnabled();
    const supportConfigItems = (getSupportConfigItems() ||
        []);
    return (React.createElement(GlobalAlertContextProvider, null,
        React.createElement(HelpMenu, { baseReleaseVersion: baseReleaseVersion, helpItems: helpConfigList, inAppHelpUrl: inAppHelpUrl, isIntercomEnabled: intercomEnabled, isSaaSCluster: saasCluster, learningModule: learningModule, onlineDocUrl: onlineDocUrl, openExternalUrlInNewTab: navService.openExternalUrlInNewTab, releaseVersion: releaseVersion, sendMixpanelEvent: sendMixpanelEvent, showPendoHelpMenu: isPendoHelpEnabled, stopReplay: observabilityService?.stopReplay, supportConfigItems: supportConfigItems, watchForFullReplay: observabilityService?.watchForFullReplay })));
};
//# sourceMappingURL=help-menu.container.js.map